import React from "react"
import EmailIcon from "../assets/email-2.svg"
import {
  NewsletterFormContainer,
  NewsletterFormLeftSide,
  NewsletterFormRightSide,
  SmallBottomPadding,
  TitleText,
  SecondaryText,
  NewsletterInput,
  SubscribeButton,
  SubscribeText,
  NoSpamText,
} from "./styles"

const NewsletterForm = () => (
  <form
    action={`https://app.convertkit.com/forms/${1314700}/subscriptions`}
    method="post"
  >
    <NewsletterFormContainer>
      <NewsletterFormLeftSide>
        <SmallBottomPadding>
          <TitleText>Subscribe to the Newsletter</TitleText>
        </SmallBottomPadding>
        <SecondaryText>Subscribe to my latest content by email.</SecondaryText>
        <EmailIcon height={60} width={60} />
      </NewsletterFormLeftSide>
      <NewsletterFormRightSide>
        <NewsletterInput
          placeholder="Your first name"
          aria-label="Your first name"
          name="fields[first_name]"
          type="text"
          required
        />
        <NewsletterInput
          placeholder="Your email address"
          aria-label="Your email address"
          name="email_address"
          type="email"
          required
        />
        <SubscribeButton type="submit">
          <SubscribeText>Subscribe</SubscribeText>
        </SubscribeButton>

        <NoSpamText>
          I won’t spam.
          <br /> Unsubscribe any time.
        </NoSpamText>
      </NewsletterFormRightSide>
    </NewsletterFormContainer>
  </form>
)

export default NewsletterForm
